import { defineStore } from 'pinia'
import { verifyEmail, login, postReaction } from './api/user'

export const useGlobalStore = defineStore('global', {
    state: () => ({
        webspace: '',
        locale: '',
        recaptcha: '',
        user: {
            type: null,
            id: null,
            company: '',
            username: '',
            formOfAddress: 0,
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            phoneMobile: '',
            address: {
                street: '',
                number: '',
                postcode: '',
                town: '',
                country: ''
            },
            meta: {
                areYou: null,
                education: null,
                experience: null,
                capital: null,
            },
            isIntermediary: false,
            isFranchise: false,
            isEntrepeneurPremium: false,
            isEntrepeneur: false,
            has_premium: false,
            num_favorites: 0,
            num_reactions: 0,
            can_login: false,
        },
        reaction: {
            body: '',
            register_newsletter: false,
            agree_terms: false,
        },
    }),
    actions: {
        async verifyEmail(url: string) {
            const data = await verifyEmail(url, this.user.email);

            if (!data?.success && data?.can_login) {
                this.user.can_login = true;
            }

            return data;
        },
        async login(url: string, password: string, remember: boolean) {
            const data = await login(url, this.user.email, password, remember);

            if (data?.success) {
                this.user = data.user;
            }

            return data;
        },
        async postReaction(url: string, new_password: string) {
            const data = await postReaction(url, this.user, this.reaction, new_password);

            if (data?.success) {
                this.user = data.user;
                this.reaction.body = '';
                this.reaction.register_newsletter = false;
                this.reaction.agree_terms = false;
            }

            return data;
        }
    },
})